import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './service/api/api.service';
import { NgSelectConfig } from '@ng-select/ng-select';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  title = 'CoreUI Pro Angular Admin Template';

  constructor(private router: Router, private iconSetService: IconSetService, private translate: TranslateService, private api: ApiService,private config: NgSelectConfig) {
    iconSetService.icons = { ...iconSubset };

    translate.addLangs(['fr', 'en','pt']);
    translate.setDefaultLang('fr');
    
    this.config.notFoundText = 'Aucun résultat trouvé';
    this.config.appendTo = 'body';
    // set the bindValue to global config when you use the same
    // bindValue in most of the place.
    // You can also override bindValue for the specified template
    // by defining `bindValue` as property
    // Eg : <ng-select bindValue="some-new-value"></ng-select>
    // this.config.bindValue = 'value';
    this.config.disableVirtualScroll = false;
    this.config.clearAllText = 'Tout effacer';
    this.config.loadingText = 'Chargement...';
  }

  async ngOnInit(): Promise<void> {
    let currentLang:string = await this.api.get_from_local_storage("currentLang")||'fr'
    this.translate.use(currentLang);
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });
  }
}
